import { defineMessages } from 'react-intl';

export default defineMessages({
    last5Digits: {
        id: 'adac.login-page.Last 5 digits of claim number',
        defaultMessage: 'Last 5 digits of claim number'
    },
    licensePlate: {
        id: 'adac.login-page.License plate',
        defaultMessage: 'License plate'
    },
    membershipNumber: {
        id: 'adac.login-page.Membership number',
        defaultMessage: 'Membership number'
    },
    dateOfBirth: {
        id: 'adac.login-page.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    register: {
        id: 'adac.login-page.Register',
        defaultMessage: 'Register'
    },
    termsOfUseText: {
        id: 'adac.login-page.Terms of use text',
        defaultMessage: 'Our { termsOfUse }'
    },
    termsOfUse: {
        id: 'adac.login-page.Terms of use',
        defaultMessage: 'Terms of use'
    },
    termsOfUseLink: {
        id: 'adac.login-page.terms of use link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/nutzungsbedingungen/'
    },
    dataProtectionText: {
        id: 'adac.login-page.Data protection text',
        defaultMessage: 'Our { dataProtection }'
    },
    dataProtection: {
        id: 'adac.login-page.Data protection',
        defaultMessage: 'Data protection'
    },
    dataProtectionLink: {
        id: 'adac.login-page.datap rotection link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/'
    },
    error: {
        id: 'adac.login-page.Login failed. Please check your input data',
        defaultMessage: 'Login failed. Please check your input data'
    },
    placeholder: {
        id: 'adac.login-page.DateFormat',
        defaultMessage: 'DD.MM.YYYY'
    },
    membershipNumberPlaceholder: {
        id: 'adac.login-page.12345',
        defaultMessage: '12345'
    },
    licensePlatePlaceholder: {
        id: 'adac.login-page.ADAC12345',
        defaultMessage: 'ADAC12345'
    }
});
